import { createSlice } from '@reduxjs/toolkit';

//Constants
import { sectionsSidebarSign } from '@/constants';

const initialState = sectionsSidebarSign.SIGN;

const sidebarSectionsSlice = createSlice({
  name: 'sidebarSections',
  initialState,
  reducers: {
    toggleSection: (state, action) => {
      return action.payload;
    }
  }
});

export const { toggleSection } = sidebarSectionsSlice.actions;
export default sidebarSectionsSlice.reducer;
